import React from 'react';
import PropTypes from 'prop-types';
import CommentField from './commentField';
import NameField from './nameField';
import PhotosArea from './photosArea';

const CommentsInputPage = props => {
  let celebrationHeadlineNotService;
  let weInviteYouToComment;
  let timeToCelebrate;
  let createExperience;
  let writeANote;
  let showPhotosArea;
  let addCongrats;

  if (props.translations['time-to-celebrate']) {
    celebrationHeadlineNotService = props.translations[
      'celebration-headline-not-service'
    ].replace('%{name}', props.comment.user.firstName);



    // TODO:  #1 If NYP
    console.info('STP:  ');
    console.info(props.comment.user.stp);
    console.info('Program Type:  ');
    console.info(props.comment.program.type);
    if(props.comment.user.stp === '0001170328' && props.comment.program.type === 'Retirement') {
      celebrationHeadlineNotService = '';
    }

    weInviteYouToComment = props.translations[
      'we-invite-you-to-comment'
    ].replace(/%{name}/g, props.comment.user.firstName);

    // TODO:  #2 If NYP
    if(props.comment.user.stp === '0001170328' && props.comment.program.type === 'Retirement') {
      weInviteYouToComment = 'We invite you to add a message that will display in a Yearbook we are creating to honor %{name}. Whether it is a brief note, a shared story or memory or a few lines paying tribute to %{name}, each comment adds up to an incredibly personal, powerful and memorable keepsake.'.replace(/%{name}/g, props.comment.user.firstName);
    }

    timeToCelebrate = props.translations['time-to-celebrate']
      .replace('%{name}', props.comment.user.firstName)
      .replace('%{level}', props.comment.level);
    createExperience = props.translations['create-experience'].replace(
      '%{name}',
      props.comment.user.firstName,
    );

    // TODO:  #6 If NYP
    if(props.comment.user.stp === '0001170328' && props.comment.program.type === 'Retirement') {
      createExperience = 'Please help create a personalized experience, this is your chance to honor %{name}. Your note can include examples of their great work, how they made an impact on the team or your favorite memory together.'.replace(/%{name}/g, props.comment.user.firstName);
    }

    writeANote = props.translations['write-a-note'].replace(
      '%{name}',
      props.comment.user.firstName,
    );

    addCongrats = props.translations['add-congrats'];

    // TODO:  #3 If NYP
    if(props.comment.user.stp === '0001170328' && props.comment.program.type === 'Retirement') {
      writeANote = 'Please enter your note';
      addCongrats = 'Please enter your note';
    }

  }

  if (
    props.comment.program &&
    (props.comment.program.peer || props.comment.program.manager)
  ) {
    showPhotosArea = props.isLeader
      ? props.comment.program.manager.image.allowed
      : props.comment.program.peer.image.allowed;
  }

  return (
    <form>
      <h4 className="deadline">
        {/* eslint-disable */}
        <span dangerouslySetInnerHTML={{ __html: props.commentByDate }} />
        {/* eslint-enable */}
      </h4>
      <h1>
        {props.comment.program.type === 'Service'
          ? timeToCelebrate
          : celebrationHeadlineNotService}
      </h1>
      {props.isLeader ? (
        <p className="narration">{createExperience}</p>
      ) : (
        <p>{weInviteYouToComment}</p>
      )}

      <CommentField
        translations={props.translations}
        title={props.isLeader ? writeANote : addCongrats}
        error={props.error}
        bannedWordError={props.bannedWordError}
        color={props.comment.program.color}
        maxlength={props.comment.comment.input.comment.maxlength}
        displayModal={props.displayModal}
        comment={props.tempComment.comment}
        addTempUserComment={props.addTempUserComment}
        doubleByteExists={props.tempComment.doubleByteExists}
        isLeaderComment={props.isLeader}
        emojiExists={props.tempComment.emojiExists}
      />

      <NameField
        translations={props.translations}
        maxlength={props.comment.comment.input.name.maxlength}
        error={props.error}
        name={props.tempComment.name}
        addTempUserName={props.addTempUserName}
      />

      {showPhotosArea && (
        <PhotosArea
          translations={props.translations}
          comment={props.comment}
          uploadImage={props.uploadImage}
          imageLoading={props.imageLoading}
          uploadedImages={props.uploadedImages}
          deleteUploadedPhoto={props.deleteUploadedPhoto}
          rotatePhoto={props.rotatePhoto}
          autoOrientImage={props.autoOrientImage}
          displayModal={props.displayModal}
          isLeader={props.isLeader}
          error={props.error}
          imageInputErrorCodes={props.imageInputErrorCodes}
        />
      )}

      <div className="clearfix">
        <button
          type="button"
          style={{ backgroundColor: props.comment.program.color }}
          onClick={props.validateCommentForm}
        >
          {props.translations['preview-comment']}
        </button>
      </div>
    </form>
  );
};

CommentsInputPage.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  comment: PropTypes.shape({
    comment: PropTypes.shape({
      input: PropTypes.shape({
        name: PropTypes.shape({
          maxlength: PropTypes.number,
        }),
        comment: PropTypes.shape({
          maxlength: PropTypes.number,
        }),
      }),
    }),
    program: PropTypes.shape({
      peer: PropTypes.shape({
        image: PropTypes.shape({
          allowed: PropTypes.bool,
        }),
      }),
      manager: PropTypes.shape({
        image: PropTypes.shape({
          allowed: PropTypes.bool,
        }),
      }),
      type: PropTypes.string,
      color: PropTypes.string,
    }),
    level: PropTypes.string,
    user: PropTypes.shape({
      firstName: PropTypes.string,
      stp: PropTypes.string,
    }),
  }).isRequired,
  commentByDate: PropTypes.string.isRequired,
  validateCommentForm: PropTypes.func.isRequired,
  isLeader: PropTypes.bool.isRequired,
  tempComment: PropTypes.shape({
    comment: PropTypes.string,
    name: PropTypes.string,
    doubleByteExists: PropTypes.bool,
    emojiExists: PropTypes.bool,
  }),
  error: PropTypes.string,
  bannedWordError: PropTypes.string,
  imageLoading: PropTypes.number,
  uploadedImages: PropTypes.array,
  imageInputErrorCodes: PropTypes.array,
  displayModal: PropTypes.func,
  uploadImage: PropTypes.func,
  deleteUploadedPhoto: PropTypes.func,
  rotatePhoto: PropTypes.func,
  autoOrientImage: PropTypes.func,
  addTempUserComment: PropTypes.func,
  addTempUserName: PropTypes.func,
};

CommentsInputPage.defaultProps = {
  tempComment: {},
  error: '',
  bannedWordError: '',
  imageLoading: null,
  uploadedImages: [],
  imageInputErrorCodes: [],
  displayModal: () => {},
  uploadImage: () => {},
  deleteUploadedPhoto: () => {},
  rotatePhoto: () => {},
  autoOrientImage: () => {},
  addTempUserComment: () => {},
  addTempUserName: () => {},
};

export default CommentsInputPage;
